<template>
  <div class="box">
    <div class="rightImgEditor">
      <div
        class="info"
        v-if="isCompareImage === 2"
      >{{info.time | filterTime}} {{info.position_detail}}</div>
      <div
        style="width: 100%;"
        ref="canvasWrapper"
        class="canvasWrapper"
        :class="{contrast: isCompareImage === 2}"
        @dblclick="dblclickImage"
      >
        <signDetails
          class="signDetails"
          :signDetails="signDetails"
          :toggleStatusSign="toggleStatusSign"
          :signId="signId"
          :detail_title="detail_title"
          :sign_no="sign_no"
          @setsign_no="setsign_no"
          @setTitle_detail="setTitle_detail"
        ></signDetails>
        <AddsignDialog @updateSignId="updateSignId"></AddsignDialog>

        <canvas width="1006" height="674" ref="crp"></canvas>
        <div
          class="map00"
          v-show="toggleStatus||toggleStatusSign"
          :style="mapStyle"
          @mousedown="mousedown()"
          @mouseup="mouseup()"
          @dblclick="addSign()"
        ></div>
      </div>
      <div class="selected" v-if="isCompareImage === 2">
        <div class="selected-toggle active" v-show="selected"></div>
        <div class="selected-toggle" v-show="!selected"></div>
      </div>
      <div class="option-box" :class="{contrasts: isCompareImage === 2}">
        <div class="optionWrapper" :class="imageCompileClass" v-show="selected">
          <div class="btn-wrap">
            <i
              class="el-icon-zoom-in font-zoom"
              @click="zoomHandler(0.1)"
              @mousedown.stop="addActive($event)"
              @mouseup="removeActive($event)"
            ></i>
            <i
              class="el-icon-zoom-out font-zoom"
              @click="zoomHandler(-0.1)"
              @mousedown.stop="addActive($event)"
              @mouseup="removeActive($event)"
            ></i>
            <i
              class="iconfont icon-nishizhenxuanzhuan rotate"
              @click="rotateHandler(-5)"
              @mousedown.stop="addActive($event)"
              @mouseup="removeActive($event)"
            ></i>
            <i
              class="iconfont icon-shunshizhenxuanzhuan rotate"
              @click="rotateHandler(5)"
              @mousedown.stop="addActive($event)"
              @mouseup="removeActive($event)"
            ></i>
            <i
              class="iconfont icon-one-line-arrow rotate"
              @click="isArrow($event)"
              v-if="info.position_detail !== '入院照片' && info.position_detail !== '出院照片'"
            ></i>
            <i
              class="iconfont icon-line rotate"
              @click="isLine($event)"
              v-if="info.position_detail !== '入院照片' && info.position_detail !== '出院照片'"
            ></i>
            <i
              class="iconfont icon-wenzi1 rotate"
              @click="isText($event)"
              v-if="info.position_detail !== '入院照片' && info.position_detail !== '出院照片'"
            ></i>
            <i
              class="iconfont icon-juxing rotate"
              @click="isRect($event)"
              v-if="info.position_detail !== '入院照片' && info.position_detail !== '出院照片'"
            ></i>
            <i
              class="iconfont icon-big-circle rotate"
              @click="isCircle($event)"
              v-if="info.position_detail !== '入院照片' && info.position_detail !== '出院照片'"
            ></i>
            <i
              class="iconfont icon-tiaoseban rotate"
              :style="{'color':$store.state.clolrPickerDefault}"
              v-if="info.position_detail !== '入院照片' && info.position_detail !== '出院照片'"
            >
              <el-color-picker
                popper-class="picker_choose"
                v-model="$store.state.clolrPickerDefault"
              ></el-color-picker>
            </i>
          </div>
          <div class="btn3-wrap">
            <div class="saveClass" @click="showOriginPic" v-if="this.info && this.info.origin">查看原图</div>
            <!-- <div class="saveClass" @click="toggleSign()" v-if="info.position_detail !== '入院照片' && info.position_detail !== '出院照片'&&info.tplType">显示标记点</div> -->
            <div
              class="saveClass"
              @click="toggleSign()"
              v-if="info.position_detail !== '入院照片' && info.position_detail !== '出院照片'&&info.tplType=='hairdressing'"
            >{{signText}}标记点</div>
            <div
              class="saveClass"
              @click="toggleOther()"
              v-if="info.position_detail !== '入院照片' && info.position_detail !== '出院照片'"
            >{{drwaText}}其他标记</div>
            <div
              class="saveClass"
              @click="saveKonva()"
              v-if="info.position_detail !== '入院照片' && info.position_detail !== '出院照片'"
            >保存</div>
            <div class="saveClass" @click="restart">重置</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "cropper/dist/cropper.css";
import Cropper from "cropperjs";
import Util from "../utils/utils.js";
import { konvaDraw } from "../utils/konvaDraw.js";
import moment from "moment";
import addKonva from "../gql/addKonva.gql";
import crypto from "crypto";
import axios from "axios";
import signDetails from "./SignDetails.vue";
import AddsignDialog from "./AddsignDialog.vue";
import modifyCosmetologyImage from "../gql/modifyCosmetologyImage.gql";

export default {
  name: "EditImg",
  data() {
    return {
      cropper: "",
      currentImg: "",
      myCanvas: "",
      img: null,
      // 是否滚动
      isScroll: false,
      currentIndex: 0,
      mapStyle: {
        width: 100,
        height: 100,
        top: 0,
        left: 0,
        transform: "scale(1)"
      },
      type: {
        1: "dt",
        2: "sk",
        4: "sk",
        8: "CT",
        16: "B_ultrasonic",
        32: "pathology"
      },
      canClickOrigin: true
    };
  },
  provide() {
    return {
      isOpenDialog: this.a
    };
  },
  mixins: [konvaDraw],
  components: {
    signDetails,
    AddsignDialog
  },
  props: {
    info: Object,
    largeImgage: String,
    imageCompileClass: String,
    selected: Boolean,
    isCompareImage: Number
  },
  async mounted() {
    this.$nextTick(() => {
      this.drawImage(this.largeImgage);
    });
  },
  methods: {
    // 查看原始图片
    async showOriginPic() {
      if (this.canClickOrigin) {
        try {
          if (!window.localStorage.system_set) {
            this.$message.error("未获取到远程ip地址");
          } else {
            if (this.info.type !== 0) {
              this.canClickOrigin = false;
              const system_set = JSON.parse(localStorage.system_set);
              if (
                system_set[this.type[this.info.type]].ip &&
                system_set[this.type[this.info.type]].port
              ) {
                // 获取http地址
                const url = `https://${system_set[this.type[this.info.type]].ip}:${system_set[this.type[this.info.type]].port}`;
                // 请求key并算出secret
                const msgKey = await axios.get(url + "/key");
                const secret = crypto
                  .createHash("sha1")
                  .update(
                    msgKey.data.key
                      .split("")
                      .reverse()
                      .join("")
                  )
                  .digest("hex");
                window.open(
                  url + "/" + this.info.origin + "?secret=" + secret,
                  "_blank"
                );
                this.canClickOrigin = true;
              } else {
                this.$message.error("远程ip地址错误");
              }
            }
          }
        } catch (error) {
          this.$message.error("远程ip地址错误");
          this.canClickOrigin = true;
        }
      }
    },
    // 双击图片时不出现裁剪框
    dblclickImage() {
      this.cropper.onDblclick();
      return false;
    },
    // 画图片方法
    drawImage(src) {
        console.log(src)
      this.$nextTick(() => {
        let img = new Image();
          console.log(src)
        // 设置跨域必须放到img.src前面
        img.setAttribute("crossOrigin", "anonymous");

        img.src = src;
        const that = this;
        new Promise((resolve, reject) => {
          img.onload = () => {
            let whRatio = img.width / img.height;
            if (img.width / img.height < 1006 / 674) {
              // 适配高度
              img.height = 674;
              img.width = whRatio * img.height;
            } else {
              // 适配宽度
              img.width = 1006;
              img.height = img.width / whRatio;
            }
            const myCanvas = that.$refs.crp;
            resolve(myCanvas);
          };
        }).then(data => {
          let ctx = data.getContext("2d");
          ctx.clearRect(0, 0, 1006, 674);
          let offsetLeft = 1006 - img.width;
          let offsetHeight = 674 - img.height;
          ctx.drawImage(
            img,
            offsetLeft / 2,
            offsetHeight / 2,
            img.width,
            img.height
          );
          if (that.cropper === "") {
            that.cropper = new Cropper(data, {
              guides: false,
              imageSmoothingEnabled: false,
              autoCrop: false,
              background: false,
              zoomable: true,
              ready() {
                that.moveHandler();
                that.getImageData();
              }
            });
          } else {
            that.cropper.destroy();
            that.cropper = null;
            that.cropper = new Cropper(data, {
              guides: false,
              imageSmoothingEnabled: false,
              autoCrop: false,
              background: false,
              zoomable: true,
              ready() {
                that.moveHandler();
                that.getImageData();
              }
            });
          }
        });
      });
    },
    showScroll() {
      this.isScroll = true;
    },
    hidenScroll() {
      this.isScroll = false;
    },

    back() {
      // 返回到上一个页面
      this.$emit("cancel");
    },
    zoomHandler(num) {
      if (this.editMode.classList) {
        this.editMode.classList.remove("active");
      }
      this.cropper.zoom(num);
      this.toggleMap(false);
    },
    // 点击按下添加class
    addActive(event) {
      event.srcElement.classList.add("active");
    },
    // 点击抬起删除class
    removeActive(event) {
      event.srcElement.classList.remove("active");
    },
    getImageData() {
      this.mapStyle.width = this.cropper.getImageData().width + "px";
      this.mapStyle.height = this.cropper.getImageData().height + "px";
      this.mapStyle.top = this.cropper.getCanvasData().top + "px";
      this.mapStyle.left = this.cropper.getCanvasData().left + "px";
      this.setKonva(
        ".map00",
        this.cropper.getImageData().width,
        this.cropper.getImageData().height
      );
    },
    rotateHandler(num) {
      if (this.editMode.classList) {
        this.editMode.classList.remove("active");
      }
      this.cropper.rotate(num);
      this.toggleMap(false);
    },
    moveHandler() {
      this.cropper.setDragMode("move");
      this.toggleMap(false);
    },
    cutHandler() {
      this.cropper.setDragMode("crop");
      this.toggleMap(false);
    },
    enterHandler() {
      const imgData = this.cropper.getCroppedCanvas();
      const dataUrl = imgData.toDataURL("image/jpg");
      const imgIndex = this.imglist[this.currentIndex];
      this.$emit("getImgSrc", { imgData: dataUrl, currentImg: imgIndex });
    },
    restart() {
      // 重新修剪
      this.cropper.reset();
    },
    getImgSrc(data) {
      this.currentImg = data;
    },
    async saveKonva() {
      let data = {};
      data.width = this.cropper.getImageData().width;
      data.height = this.cropper.getImageData().height;
      data.children = this.layer.children;
      data.childrenSign = this.layerSign.children;

      try {
        let mutations;
        if (this.info.tplType === "hairdressing") {
          mutations = modifyCosmetologyImage;
        } else {
          mutations = addKonva;
        }

        let res = await this.$apollo.mutate({
          mutation: mutations,
          variables: {
            id: this.info.id ? this.info.id : "",
            annotation: JSON.stringify(data)
          }
        });
        this.$message({
          message: "右图标注已保存",
          type: "success"
        });
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    alertNoIp() {
      if (!this.isHaveOriginUrl) {
        alert("远程IP地址错误");
      }
    }
  },
  watch: {
    largeImgage() {
      this.$nextTick(() => {
        this.drawImage(this.largeImgage);
      });
    }
  },
  filters: {
    filterTime(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    }
  }
};
</script>
<style scoped lang="less">
/*
        修改滚动条样式
    */
/*::-webkit-scrollbar {*/
/*width: 5px;*/
/*height: 100%;*/
/*}*/

/*::-webkit-scrollbar-track-piece {*/
/*background: #fff;*/
/*-webkit-border-radius: 6px;*/
/*}*/

/*::-webkit-scrollbar-thumb:vertical {*/
/*background-color: #61a2bf;*/
/*-webkit-border-radius: 6px;*/
/*}*/

.box,
.rightImgEditor,
.optionWrapper,
.leftImgList {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
}

.returnClass,
.saveClass {
  cursor: pointer;
  background: #fff;
  width: 120px;
  height: 20px;
  padding: 10px 0;
  margin-right: 10px;
  right: 20px;
  top: 10px;
  text-align: center;
  line-height: 20px;
  border-radius: 10px;
}

.to-origin {
  display: block;
  text-decoration: none;
  color: #606266;
}

.to-origin:active {
  color: #606266;
}

.to-origin:focus {
  color: #606266;
}

.to-origin:visited {
  color: #606266;
}

.returnClass {
  position: absolute;
}

.box {
  width: 100%;
  height: 100%;

  .leftImgList {
    width: 20%;
    height: 100%;
    flex-direction: column;
    justify-content: flex-start;
    overflow-y: auto;
    box-sizing: border-box;

    .itemImg {
      margin-bottom: 20px;
      box-sizing: border-box;
    }

    .itemImg:nth-last-child {
      margin-bottom: 0px;
    }
  }

  .rightImgEditor {
    flex-direction: column;
    width: 100%;
    height: 100%;

    .canvasWrapper.contrast {
      height: 600px;
    }

    .canvasWrapper {
      height: 826px;
      position: relative;
      /*background-color: #000;*/
      .signDetails {
        position: absolute;
        z-index: 10;
      }
      .map00 {
        position: absolute;
        // top:0;
        // width:100px;
        // height:100px;
        // background:red;
        // opacity:0.5;
        // border:1px solid red;
      }
    }

    .option-box.contrasts {
      margin-top: 80px;
    }

    .option-box {
      position: relative;
      width: 100%;
      height: 64px;
      margin-top: 10px;
    }

    .optionWrapper {
      width: 100%;
      height: 54px;
      background: #61a2bf;
      padding: 5px 0;
      justify-content: space-between;

      .btn-wrap {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 50%;

        .font-zoom {
          width: 40px;
          height: 40px;
          color: #ffffff;
          font-size: 40px;
          cursor: pointer;
        }

        .rotate {
          width: 40px;
          height: 40px;
          color: #ffffff;
          font-size: 32px;
          cursor: pointer;
        }

        .rotate::before {
          line-height: 40px;
        }

        .rotate.active::before {
          color: #e9ad05;
        }

        .font-zoom.active::before {
          color: #e9ad05;
        }
      }

      .btn3-wrap {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 43%;
      }
    }

    .optionWrapper.left {
      position: absolute;
      left: 0;
      bottom: 0;
      /*width: 1600px;*/
      width: 204%;
      padding: 5px 0;
      justify-content: space-between;
      z-index: 1;
      background: linear-gradient(
        to right,
        #5a97b4 20%,
        rgba(97, 162, 191, 0.8) 80%
      );
    }

    .optionWrapper.right {
      position: absolute;
      right: 1px;
      bottom: 0;
      /*width: 1600px;*/
      width: 204%;
      padding: 5px 0;
      justify-content: space-between;
      z-index: 1;
      background: linear-gradient(
        to left,
        #5a97b4 20%,
        rgba(97, 162, 191, 0.8) 80%
      );
    }

    .selected {
      display: flex;
      align-items: center;
      height: 26px;
      z-index: 1;
      cursor: pointer;

      .selected-toggle {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #eee;
      }

      .selected-toggle.active {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: 2px solid #eee;
        background-color: #61a2bf;
      }
    }

    .info {
      display: flex;
      align-items: flex-end;
      width: 100%;
      height: 120px;
      padding-bottom: 10px;
      color: #fff;
      background-color: #000;
      font-size: 18px;
      font-weight: bold;
      line-height: 30px;
      z-index: 1;
      text-indent: 20px;
    }
  }
}

.icon-tiaoseban {
  position: relative;
}

.el-color-picker {
  position: absolute;
  left: 0;
  right: 0;
  opacity: 0;
}
</style>


